// extracted by mini-css-extract-plugin
module.exports = {"LessonTour":"frontend-common-styles-LessonTour__LessonTour--2axZX","tourContent":"frontend-common-styles-LessonTour__tourContent--2LzYX"};